module.exports = __webpack_public_path__ + "static/media/Detail.e5da4ebc.png";